import axios from 'axios';
import { getAxiosBaseURL } from '../config/apiBase';
import { normalizeJsonWriteData } from './jsonWriteBody';

const API_URL = getAxiosBaseURL();

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    if (!config.baseURL) {
      return Promise.reject(
        new Error('API URL is not configured. Set REACT_APP_API_URL in frontend/.env and restart or rebuild.')
      );
    }
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.data = normalizeJsonWriteData(config.data, config.method);
    if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');

      const currentPath = window.location.pathname;
      if (currentPath !== '/login' && currentPath !== '/register') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
